export class SPEED {
  static FAST = 3
  static Medium = 2
  static SLOW = 1
  static NONE = 0
}
